
const config = {
	// BASE_URL: "http://49.232.119.48:8080",  //基础路径
	BASE_URL: "https://hebotc.com",  //基础路径
	
};

export default config



//////////////////
// WEBPACK FOOTER
// ./base/config.js
// module id = null
// module chunks = 